<template>
  <div>
    <b-card-actions
      v-for="(zone, zoneId) in zones"
      :key="zoneId"
      collapsed
      action-collapse
      :title="zone.city"
    >
      <b-form-group>
        <b-form-checkbox-group
          v-model="selectedServices[zoneId]"
          stacked
        >
          <b-form-checkbox
            v-for="service in services"
            :key="service.value"
            class="mb-1"
            :value="service.value"
          >
            {{ service.text }}
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>
      <b-button
        variant="primary"
        @click="updateZonesServices(zoneId)"
      >
        <span
          class="text-nowrap"
        >Save</span>
      </b-button>
    </b-card-actions>
  </div>
</template>

<script>
import {
  BButton, BFormCheckboxGroup, BFormCheckbox, BFormGroup,
} from 'bootstrap-vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import { reduce } from 'lodash/collection'
import { reactive } from '@vue/composition-api'
import store from '@/store'

export default {
  components: {
    BFormCheckboxGroup,
    BFormCheckbox,
    BFormGroup,
    BButton,

    BCardActions,
  },
  setup() {
    const getZoneId = zone => `${zone.country}::${zone.city}`
    const serviceId = service => `${service.service}::${service.class}`
    const services = store.getters['services/services'].map(service => ({
      text: `${service.serviceLabel}-${service.classLabel}`,
      value: serviceId(service),
    }))
    const selectedServices = reactive({})
    const zones = reduce(store.getters['zones/zones'], (result, zone) => {
      // eslint-disable-next-line no-param-reassign
      result[getZoneId(zone)] = zone
      selectedServices[getZoneId(zone)] = [...zone.services]
      return result
    }, {})

    return {
      services,
      zones,
      selectedServices,
      serviceId,
      getZoneId,
    }
  },
  methods: {
    async updateZonesServices(zoneId) {
      const result = await this.$swal({
        title: 'Are you sure?',
        text: 'You want to apply this action?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, update it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      })
      if (result.value) {
        await store.dispatch('zones/putZoneServices', {
          zone: zoneId,
          services: this.selectedServices[zoneId],
        })
        this.$swal({
          icon: 'success',
          title: 'Saved',
          text: 'Services has been updated!',
          customClass: {
            confirmButton: 'btn btn-success',
          },
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
